export default function scrollToEl(ref, offset = 240, threshold = 100) {
  const pos = ref.current.getBoundingClientRect()
  if (pos.top < threshold)
    window.scrollBy({
      top: pos.top - offset,
      behavior: 'smooth',
    })
}
